
import { useContext } from 'react';
import { ServiceWorkerContext } from 'contexts/service_worker_context';

const useServiceWorkerContext = () => {
    return useContext(ServiceWorkerContext);
};

export default useServiceWorkerContext;
